<section class="review-estimate-details" data-testid="review-estimate-details">
  <puro-typography component="h2" variant="h4" class="review-estimate-details__title">
    {{ titleKey() | translate }}
  </puro-typography>

  <div class="review-estimate-details__columns">
    <div class="review-estimate-details__service">
      @if (arrivalLabel()) {
        <puro-typography component="p" variant="body1" class="review-estimate-details__arrival">
          {{ arrivalLabel() }}
        </puro-typography>
      }
      @if (selectedService(); as service) {
        <div class="review-estimate-details__card" data-testid="review-selected-service">
          @if (service.badge === 'fastest') {
            <div class="review-estimate-details__badge" data-testid="review-selected-service-badge">
              {{ 'createShipment.serviceStep.deliveryService.badges.fastest' | translate }}
            </div>
          } @else if (service.badge === 'mostEconomical') {
            <div class="review-estimate-details__badge" data-testid="review-selected-service-badge">
              {{ 'createShipment.serviceStep.deliveryService.badges.mostEconomical' | translate }}
            </div>
          }
          <div class="review-estimate-details__card-body">
            <div class="review-estimate-details__card-details">
              <puro-typography component="p" variant="h5" class="review-estimate-details__product">
                {{ service.displayName }}
              </puro-typography>
              @if (service.commitmentLabel) {
                <puro-typography
                  component="p"
                  variant="body2"
                  class="review-estimate-details__guaranteed"
                  data-testid="review-selected-service-commitment"
                >
                  {{ service.commitmentLabel }}
                </puro-typography>
              } @else if (service.guaranteed) {
                <puro-typography
                  component="p"
                  variant="body2"
                  class="review-estimate-details__guaranteed"
                  data-testid="review-selected-service-commitment"
                >
                  {{ 'createShipment.reviewAndPay.estimate.guaranteedEndOfDay' | translate }}
                </puro-typography>
              }
            </div>
            <p class="review-estimate-details__cost">
              <span class="review-estimate-details__cost-label">
                {{ 'createShipment.serviceStep.deliveryService.estimatedCostLabel' | translate }}
              </span>
              <span class="review-estimate-details__cost-value">
                @if (service.discountedPricing) {
                  {{ formatCurrencyAmount(service.discountedPricing.totalPrice) }}
                } @else {
                  {{ formatCurrencyAmount(service.pricing.totalPrice) }}
                }
              </span>
            </p>
          </div>
        </div>
      }
    </div>

    <div class="review-estimate-details__breakdown">
      @if (breakdown(); as view) {
        <div class="review-estimate-details__row">
          <span class="review-estimate-details__label">
            <puro-typography component="span" variant="body2">
              {{ 'createShipment.serviceStep.deliveryService.breakdown.baseCost' | translate }}
            </puro-typography>
          </span>
          @if (view.discountedBaseCost) {
            <puro-typography
              component="span"
              variant="body2"
              class="review-estimate-details__amount review-estimate-details__amount--list"
            >
              <s>{{ formatCurrencyAmount(view.baseCost) }}</s>
            </puro-typography>
            @if (view.discountRate !== undefined) {
              <puro-typography
                component="span"
                variant="body2"
                class="review-estimate-details__discount-label"
              >
                {{
                  'createShipment.serviceStep.deliveryService.breakdown.discountPayOnly'
                    | translate: discountParams(view.discountRate)
                }}
              </puro-typography>
            }
            <puro-typography
              component="span"
              variant="body2"
              class="review-estimate-details__amount review-estimate-details__amount--pay"
            >
              <strong>{{ formatCurrencyAmount(view.discountedBaseCost) }}</strong>
            </puro-typography>
          } @else {
            <puro-typography
              component="span"
              variant="body2"
              class="review-estimate-details__amount"
            >
              {{ formatCurrencyAmount(view.baseCost) }}
            </puro-typography>
          }
        </div>

        @if (view.additionalSurcharges.length > 0) {
          <div class="review-estimate-details__surcharges">
            <puro-typography
              component="p"
              variant="body2"
              class="review-estimate-details__surcharges-title"
            >
              {{
                'createShipment.serviceStep.deliveryService.breakdown.additionalSurcharges'
                  | translate
              }}
            </puro-typography>
            @for (line of view.additionalSurcharges; track line.code + line.listAmount) {
              <div class="review-estimate-details__row">
                <span class="review-estimate-details__surcharge-label">
                  @if (line.descriptionKey && hasDistinctDescription(line)) {
                    <puro-typography component="span" variant="body2">
                      {{ surchargeLabelKey(line.labelCode) | translate }}<br />
                      {{ line.descriptionKey | translate: line.descriptionParams }}
                    </puro-typography>
                  } @else if (line.description && hasDistinctDescription(line)) {
                    <puro-typography component="span" variant="body2">
                      {{ surchargeLabelKey(line.labelCode) | translate }}<br />
                      {{ line.description }}
                    </puro-typography>
                  } @else {
                    <puro-typography component="span" variant="body2">
                      {{ surchargeLabelKey(line.labelCode) | translate }}
                    </puro-typography>
                  }
                </span>
                @if (line.displayMode === 'included') {
                  <puro-typography
                    component="span"
                    variant="body2"
                    class="review-estimate-details__amount"
                  >
                    {{
                      'createShipment.serviceStep.deliveryService.breakdown.included' | translate
                    }}
                  </puro-typography>
                } @else if (line.discountedAmount) {
                  <puro-typography
                    component="span"
                    variant="body2"
                    class="review-estimate-details__amount review-estimate-details__amount--list"
                  >
                    <s>{{ formatCurrencyAmount(line.listAmount) }}</s>
                  </puro-typography>
                  @if (view.discountRate !== undefined) {
                    <puro-typography
                      component="span"
                      variant="body2"
                      class="review-estimate-details__discount-label"
                    >
                      {{
                        'createShipment.serviceStep.deliveryService.breakdown.discountPayOnly'
                          | translate: discountParams(view.discountRate)
                      }}
                    </puro-typography>
                  }
                  <puro-typography
                    component="span"
                    variant="body2"
                    class="review-estimate-details__amount review-estimate-details__amount--pay"
                  >
                    <strong>{{ formatCurrencyAmount(line.discountedAmount) }}</strong>
                  </puro-typography>
                } @else {
                  <puro-typography
                    component="span"
                    variant="body2"
                    class="review-estimate-details__amount"
                  >
                    {{ formatCurrencyAmount(line.listAmount) }}
                  </puro-typography>
                }
              </div>
            }
          </div>
        }

        <div class="review-estimate-details__taxes">
          <div class="review-estimate-details__row">
            <span class="review-estimate-details__label">
              <puro-typography component="span" variant="body2">
                {{
                  'createShipment.serviceStep.deliveryService.breakdown.fuelSurcharge' | translate
                }}
              </puro-typography>
            </span>
            @if (view.discountedFuelSurcharge) {
              <puro-typography
                component="span"
                variant="body2"
                class="review-estimate-details__amount"
              >
                {{ formatCurrencyAmount(view.discountedFuelSurcharge) }}
              </puro-typography>
            } @else {
              <puro-typography
                component="span"
                variant="body2"
                class="review-estimate-details__amount"
              >
                {{ formatCurrencyAmount(view.fuelSurcharge) }}
              </puro-typography>
            }
          </div>
          <div class="review-estimate-details__row">
            <span class="review-estimate-details__label">
              <puro-typography component="span" variant="body2">
                {{ 'createShipment.serviceStep.deliveryService.breakdown.gstHst' | translate }}
              </puro-typography>
            </span>
            @if (view.discountedGstHst) {
              <puro-typography
                component="span"
                variant="body2"
                class="review-estimate-details__amount"
              >
                {{ formatCurrencyAmount(view.discountedGstHst) }}
              </puro-typography>
            } @else {
              <puro-typography
                component="span"
                variant="body2"
                class="review-estimate-details__amount"
              >
                {{ formatCurrencyAmount(view.gstHst) }}
              </puro-typography>
            }
          </div>
        </div>

        <div class="review-estimate-details__total">
          <puro-typography component="span" variant="body1">
            {{ 'createShipment.serviceStep.deliveryService.breakdown.total' | translate }}
          </puro-typography>
          <div class="review-estimate-details__total-amount">
            <puro-typography
              component="span"
              variant="body1"
              class="review-estimate-details__amount"
            >
              {{ formatCurrencyAmount(view.total) }}
            </puro-typography>
          </div>
        </div>
      }
    </div>

    @if (showCoupon() && couponControl(); as control) {
      <app-review-coupon-code
        [couponControl]="control"
        [status]="couponStatus()"
        (applied)="applied.emit($event)"
      />
    } @else if (paymentDisplay(); as payment) {
      <div class="review-estimate-details__payment" data-testid="review-estimate-payment">
        <div class="review-estimate-details__payment-block">
          <puro-typography
            component="h3"
            variant="body1"
            class="review-estimate-details__payment-title"
          >
            {{ 'createShipment.getLabels.paymentMethod' | translate }}
          </puro-typography>
          <div class="review-estimate-details__payment-method-row">
            @if (resolvePaymentCardBrandIconSrc(payment.cardBrand); as brandIconSrc) {
              <img
                class="review-estimate-details__payment-brand-logo"
                data-testid="review-estimate-payment-brand"
                [src]="brandIconSrc"
                [alt]="formatPaymentCardBrand(payment.cardBrand)"
                width="76"
                height="48"
              />
            }
            <puro-typography
              component="p"
              variant="body2"
              class="review-estimate-details__payment-body"
            >
              {{ payment.maskedPan }}
              <br />
              {{ 'createShipment.getLabels.paymentExpiry' | translate: { expiry: payment.expiry } }}
            </puro-typography>
          </div>
        </div>
        <div class="review-estimate-details__payment-block">
          <puro-typography
            component="h3"
            variant="body1"
            class="review-estimate-details__payment-title"
          >
            {{ 'createShipment.getLabels.billingAddress' | translate }}
          </puro-typography>
          <puro-typography
            component="p"
            variant="body2"
            class="review-estimate-details__payment-body"
          >
            {{ payment.billingName }}
            <br />
            {{ payment.billingPostalCode }}
          </puro-typography>
        </div>
      </div>
    }
  </div>

  @if (showCouponLoadingOverlay()) {
    <output
      class="review-estimate-details__loading-overlay"
      aria-live="polite"
      data-testid="review-estimate-coupon-loading"
    >
      <span class="visually-hidden">
        {{ 'createShipment.reviewAndPay.estimate.couponApplying' | translate }}
      </span>
      <div class="review-estimate-details__loader" aria-hidden="true"></div>
    </output>
  }
</section>
